import { useEffect, useRef } from 'react';

// stolen https://usehooks.com/usePrevious/
export function usePrevious<T>(value: T) {
  const ref = useRef<T>(undefined);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}
